import { render, staticRenderFns } from "./my-alert.vue?vue&type=template&id=0698f05e&scoped=true"
import script from "./my-alert.vue?vue&type=script&lang=js"
export * from "./my-alert.vue?vue&type=script&lang=js"
import style0 from "./my-alert.vue?vue&type=style&index=0&id=0698f05e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0698f05e",
  null
  
)

export default component.exports